<script setup lang="ts">
import type { LinkNavTab } from '@shared/ui/menus'

import { useSidebarPrivileges } from '@entities/viewer'
import { AppRoute } from '@shared/config'
import { NavigationLinkTabs } from '@shared/ui/menus'

defineOptions({
  name: 'UsersMenu',
})

const route = useRoute()
const { canViewUsers, canViewTeams } = useSidebarPrivileges()

const config = computed<LinkNavTab[]>(() => [
  {
    text: 'Users',
    to: AppRoute.Users,
    // The Users list is `/users`; `/users/[id]` is the edit page, which shows no tab bar.
    selected: route.path === AppRoute.Users,
    disabled: false,
    visible: canViewUsers.value,
  },
  {
    text: 'Teams',
    to: AppRoute.Teams,
    selected: route.path.startsWith(AppRoute.Teams),
    disabled: false,
    visible: canViewTeams.value,
  },
])
</script>

<template>
  <NavigationLinkTabs :config="config" />
</template>
